import React from 'react';
import { Box, Button, Stack, TextField } from '@mui/material';

import { EntitySnapTarget, SerializedEntitySnapTarget } from '../../../../../library/layout-snapping/EntitySnapTarget';
import { getPickingObjectInfo } from '../../../../../store/selectors/pickingSelectors';
import {
  applicationOnPickingLayoutLine,
  clearPickingObject,
  LayoutLinePickingTarget,
} from '../../../../../store/slices/applicationSlice';
import { useAppDispatch, useAppSelector } from '../../../../hooks';

interface LayoutLinePickerFieldProps {
  label?: string;
  buttonText?: string;

  disabled?: boolean;

  target: LayoutLinePickingTarget;

  value?: string | EntitySnapTarget | SerializedEntitySnapTarget | null;

  showOnlyButton?: boolean;
}

export function LayoutLinePickerField({
  label,
  buttonText,
  disabled,
  target,
  value,
  showOnlyButton,
}: LayoutLinePickerFieldProps) {
  const dispatch = useAppDispatch();
  const pickingObjectInfo = useAppSelector(getPickingObjectInfo);

  const isPicking = pickingObjectInfo?.type === 'pickingLayoutLine';
  const thisControlIsPicking = isPicking && pickingObjectInfo.target === target;

  const valueInstance =
    value && typeof value !== 'string'
      ? value instanceof EntitySnapTarget
        ? value
        : EntitySnapTarget.fromObject(value)
      : null;

  const valueString = valueInstance ? valueInstance.toUserVisibleString() : typeof value === 'string' ? value : null;

  return (
    <Box>
      <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
        {showOnlyButton !== true && (
          <TextField
            disabled
            fullWidth
            size="small"
            variant="outlined"
            label={label ?? 'Line'}
            value={valueString ?? ''}
          />
        )}

        <Button
          variant={thisControlIsPicking ? 'contained' : 'outlined'}
          disabled={disabled || (isPicking && !thisControlIsPicking)}
          fullWidth={showOnlyButton}
          onClick={() => {
            if (thisControlIsPicking) {
              dispatch(clearPickingObject());
            } else {
              dispatch(applicationOnPickingLayoutLine({ target }));
            }
          }}
        >
          {thisControlIsPicking ? 'Picking' : (buttonText ?? 'Pick')}
        </Button>
      </Stack>
    </Box>
  );
}
